import { BlockEnum } from './../../types';
import { useStoreApi } from 'reactflow';
import { useWorkflowStore } from '../../store';
import { CrudDataType } from './types';

const useNodeExistTag = () => {
  const store = useStoreApi();
  const { getNodes } = store.getState();
  const workflowStore = useWorkflowStore();
  const algTags = workflowStore.getState().algTags;
  const allNodes = getNodes();
  const node = allNodes.filter(
    (n) =>
      n.data.type === BlockEnum.AssignmentOnline ||
      n.data.type === BlockEnum.AssignmentOffline,
  );
  // 使用reduce获取node数组内所有的tag的集合
  const tags = node.reduce((acc, cur) => {
    if (cur.data.detail.businessTags) {
      acc.push(...cur.data.detail.businessTags);
    }
    return acc;
  }, [] as string[]);
  // tags去重
  const uniqueTags = [...new Set([...algTags, ...tags])];

  // 
  const crudDatas = node.reduce((acc, cur) => {
    if (cur.data.crudDatas) {
      acc.push(...cur.data.crudDatas);
    }
    return acc;
  }, [] as CrudDataType[]);

  return {
    tags: uniqueTags,
    crudDatas
  };
};

export default useNodeExistTag;
